module.exports = __webpack_public_path__ + "img/71.4644bfbd.jpg";